import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DripCampaignSingleStage from "./drip-campaign-single-stage";
import { mapActions } from "vuex";
import { SAVE_STAGE, ADD_STAGE, DELETE_STAGE } from "../../store/drip-campaign-actions";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DripCampaignEditEmails",
  components: {
    DripCampaignSingleStage
  },
  props: {
    stages: {
      type: Array,
      required: true
    },
    campaignId: {
      type: String,
      required: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    $v: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    hasNoStages() {
      return !this.stages.length;
    }
  },
  mounted() {
    if (this.hasNoStages) {
      this.handleAddStage(true);
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DripCampaignStore", [SAVE_STAGE, ADD_STAGE, DELETE_STAGE])), {}, {
    handleChangeStage(data, index) {
      this.SAVE_STAGE({
        data,
        index
      });
    },
    handleAddStage(isFirst) {
      const newStage = {
        ccCoApplicants: false,
        sendAsSeparate: false,
        subject: "",
        previewText: "",
        templateId: "",
        templateName: "",
        templateThumbnail: "",
        daysToWait: this.hasNoStages ? 0 : 1,
        timeToSendAt: "00:00:00",
        isFirst
      };
      this.ADD_STAGE({
        data: newStage
      });
    },
    handleDeleteStage(index) {
      this.DELETE_STAGE({
        index
      });
    }
  })
});